'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});



// WEBPACK FOOTER //
// ./~/babel-polyfill/~/core-js/modules/es6.string.small.js